<div class="modal-body">
  <div class="text-center">
    <i class="cs-icon cs-icon-paper-sign text-success" style="font-size: 5rem"></i>
    <h5 class="title mt-3" i18n>Confirmation</h5>
    <div class="subtitle">
      <ng-container i18n>I agree to be legally bound by this document and</ng-container>
      <br />
      <ng-container i18n>the </ng-container
      ><a href="https://www.usesignature.com/terms.html" target="_blank" i18n>Signature Terms of Service</a>.
      <br />
      <br />
      <ng-container i18n>Click on </ng-container><span class="text-semi-bold" i18n>I Agree</span
      ><ng-container i18n> to sign this document.</ng-container>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light" aria-label="Close" *ngIf="isCancelable" (click)="close()">
    <i class="far fa-times" aria-hidden="true"></i> <ng-container i18n>Cancel</ng-container>
  </button>

  <button type="button" class="btn btn-secondary-info" (click)="onSave()">
    <i class="far fa-check" aria-hidden="true"></i> <ng-container i18n>I Agree</ng-container>
  </button>
</div>
